import { Check } from "../../../assets/icons";

import styles from "./CustomRadio.module.scss";

interface Props {
  label: string;
  value: string;
  checked: boolean;
  onChange: (value: string) => void;
}

const CustomRadio = ({ label, value, checked, onChange }: Props) => {
  return (
    <label className={styles.label}>
      <input
        type="radio"
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        className={styles.input}
      />
      <span className={styles.radio} />
      <span className={styles.text}>{label}</span>
      <span className={styles.checkmark}>{checked && <Check />}</span>
    </label>
  );
};

export default CustomRadio;
